module.exports = __webpack_public_path__ + "img/06.703a2b22.png";